import React from 'react';
import { ProductionSecurityCompliance } from '@/components/ProductionSecurityCompliance';

export default function Security() {
  return (
    <div className="space-y-6">
      <ProductionSecurityCompliance />
    </div>
  );
}